import Link from 'next/link';
import React from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { TileHyperLinkIcon } from '@web/ui/icons';

import { HubClasses, HubTile } from '../HubTile';

const SHubTile = styled(HubTile)`
  .${HubClasses.topRowContainer} {
    align-items: flex-start;
  }
`;

const IllustrationContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex: 1 0 0;
  align-self: stretch;
  overflow: hidden;
`;

const LoreImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) rotate(-2deg);
  width: 88%;
  max-width: 21rem;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 0.5rem 1.5rem rgba(0, 0, 0, 0.15));
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${({ theme }) => theme.spacing('2000')};
`;

const TextContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  gap: ${({ theme }) => theme.spacing('0750')};
`;

const Subtitle = styled.h3`
  color: ${({ theme }) => theme.color.dark};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.typescale.size['4']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.condensed};
`;

const Description = styled.p`
  color: ${({ theme }) => theme.color.dark};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
  opacity: ${({ theme }) => theme.opacity.dense};
`;

const LinkText = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
  color: ${({ theme }) => theme.color.dark};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['0875']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
  text-decoration: none;
  position: relative;
  z-index: 1;

  &:hover {
    text-decoration: underline;
  }
`;

const SHubTileStyled = styled(SHubTile)`
  background: #f4efe3;
  color: ${({ theme }) => theme.color.dark};
`;

export const LoreTile = () => {
  const t = useTranslations();

  return (
    <Link href="/lore">
      <SHubTileStyled
        textColor="dark"
        stateLayer="dark"
        title={t('LORE_HUB_TILE_TITLE')}
      >
        <IllustrationContainer>
          <LoreImage src="/lore-assets/step-1-yurei-floating.png" alt="" />
        </IllustrationContainer>

        <Content>
          <TextContainer>
            <Subtitle>{t('LORE_HUB_TILE_SUBTITLE')}</Subtitle>
            <Description>{t('LORE_HUB_TILE_DESCRIPTION')}</Description>
          </TextContainer>

          <LinkText href="/lore">
            {t('LORE_HUB_TILE_BUTTON')}
            <TileHyperLinkIcon size="0750" />
          </LinkText>
        </Content>
      </SHubTileStyled>
    </Link>
  );
};
